var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row account-edit"},[_c('div',{staticClass:"col col-xl-8 col-12"},[_c('InformationOrganization')],1),_c('div',{staticClass:"col col-xl-4 col-12"},[_c('Socials')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }